export default __webpack_public_path__ + "static/8341-367077d4f16968ad0dfa272d25506ebd.jpg";